var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeds(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seeds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "seeds_2"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53453 9.48623C6.48715 11.4388 9.1781 11.9137 10.5449 10.5469C11.9118 9.18005 11.4369 6.4891 9.48427 4.53648C7.53165 2.58386 4.8407 2.10898 3.47387 3.47582C2.10703 4.84265 2.5819 7.5336 4.53453 9.48623ZM8.10697 9.29179C8.75126 9.40548 9.03544 9.22795 9.13072 9.13267C9.226 9.03739 9.40353 8.75321 9.28983 8.10892C9.17747 7.47223 8.79179 6.67243 8.07006 5.95069C7.34833 5.22896 6.54852 4.84328 5.91183 4.73092C5.26754 4.61722 4.98336 4.79475 4.88808 4.89003C4.7928 4.98531 4.61527 5.26949 4.72897 5.91378C4.84132 6.55048 5.22701 7.35028 5.94874 8.07201C6.67047 8.79375 7.47027 9.17943 8.10697 9.29179Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57015 21.0565C12.2375 21.7712 14.8053 20.837 15.3056 18.9699C15.8059 17.1027 14.0492 15.0097 11.3819 14.295C8.71455 13.5803 6.14668 14.5146 5.64639 16.3817C5.14609 18.2488 6.90282 20.3418 9.57015 21.0565ZM12.5668 19.1019C13.1816 18.8782 13.3389 18.5824 13.3738 18.4522C13.4087 18.3221 13.4203 17.9872 12.9997 17.4861C12.5841 16.9909 11.8502 16.4911 10.8642 16.2269C9.87834 15.9627 8.99285 16.0286 8.38528 16.2497C7.77046 16.4733 7.61311 16.7692 7.57824 16.8993C7.54336 17.0295 7.53171 17.3644 7.95232 17.8655C8.36797 18.3607 9.10188 18.8605 10.0878 19.1247C11.0737 19.3888 11.9592 19.323 12.5668 19.1019Z",
    fill: "#0071CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7666 13.5469C15.1334 14.9137 17.8244 14.4388 19.777 12.4862C21.7296 10.5336 22.2045 7.84265 20.8377 6.47582C19.4708 5.10898 16.7799 5.58386 14.8273 7.53648C12.8746 9.4891 12.3998 12.1801 13.7666 13.5469ZM15.1808 12.1327C15.2761 12.228 15.5603 12.4055 16.2046 12.2918C16.8413 12.1794 17.6411 11.7937 18.3628 11.072C19.0845 10.3503 19.4702 9.55048 19.5826 8.91378C19.6963 8.26949 19.5187 7.98531 19.4235 7.89003C19.3282 7.79475 19.044 7.61722 18.3997 7.73092C17.763 7.84328 16.9632 8.22896 16.2415 8.95069C15.5197 9.67243 15.1341 10.4722 15.0217 11.1089C14.908 11.7532 15.0855 12.0374 15.1808 12.1327Z",
    fill: "#0071CD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeds);
export default __webpack_public_path__ + "static/media/seeds.a255310d8e116d2e566e723f5f366c65.svg";
export { ForwardRef as ReactComponent };